import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import About from "@/pages/about/page";
import Services from "@/pages/services/page";
import Wedding from "@/pages/wedding/page";
import WeddingStory from "@/pages/weddingStory/page";
import WeddingStories from "@/pages/weddingStories/page";
import WeddingStoryDetail from "@/pages/weddingStoryDetail/page";
import Printing from "@/pages/printing/page";
import Gallery from "@/pages/gallery/page";
import Contact from "@/pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/services",
    element: <Services />,
  },
  {
    path: "/wedding",
    element: <Wedding />,
  },
  {
    path: "/wedding-stories",
    element: <WeddingStories />,
  },
  {
    path: "/wedding-stories/aarthi-karthik",
    element: <WeddingStory />,
  },
  {
    path: "/wedding-stories/:slug",
    element: <WeddingStoryDetail />,
  },
  {
    path: "/printing",
    element: <Printing />,
  },
  {
    path: "/gallery",
    element: <Gallery />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;